<template>
  <modal name="whats-new" class="whats-new-modal modal" :click-to-close="true" height="auto">
    <div class="whats-new-modal__container" v-if="whatsNewData">

      <template v-if="!selectedDetail">
        <h2 class="whats-new-modal__header">{{ $t('login.whatsNewPopupTitle') }}</h2>

        <div class="whats-new-modal__category" v-if="features.length">{{ $t('login.features') }}</div>

        <ul class="whats-new-modal__list">
          <li v-for="(feature, i) in features" :key="i" @click="showDetails(feature)" class="whats-new-modal__list-item">
            {{ feature.title }}
          </li>
        </ul>

        <div class="whats-new-modal__category" v-if="fixes.length">{{ $t('login.fixes') }}</div>

        <ul class="whats-new-modal__list">
          <li v-for="(fix, i) in fixes" :key="i" @click="showDetails(fix)" class="whats-new-modal__list-item">
            {{ fix.title }}
          </li>
        </ul>

        <button class="button--secondary" @click="confirmModal">
          {{ $t('login.closeButtonText') }}
        </button>
      </template>

      <template v-else>
        <img v-if="selectedDetail.base64Image" :src="selectedDetail.base64Image" class="whats-new-modal__details-image" />

        <h4 class="whats-new-modal__details-header">{{ selectedDetail.title }}</h4>

        <div class="whats-new-modal__details-content">
          <p v-for="(text, i) in selectedDetail.description" :key="i">
            {{ text }}
          </p>
        </div>

        <button class="button--secondary" @click="selectedDetail=null">
          {{ $t('login.goBack') }}
        </button>
      </template>

    </div>

  </modal>
</template>

<script>
import rpcService from '@/core/services/rpc-service'
import _ from 'lodash'

export default {
  data: () => ({ selectedDetail: null, whatsNewData: null }),
  methods: {
    confirmModal() {
      rpcService.setWhatsNewTimeStamp()
      this.$modal.hide('whats-new')
    },
    showDetails(item) {
      this.selectedDetail = item
    },
    getItems(type) {
      return _.flatMap(this.whatsNew, `${this.currentLanguageCode}.${type}`)
    },
    getWhatsNewPopupData() {
      return rpcService.getWhatsNewPopupData().done((whatsNewData) => {
        this.whatsNewData = whatsNewData
        if(this.whatsNew.length > 0) {
          this.$modal.show('whats-new')
        }
      })
    }
  },
  computed: {
    whatsNew() {
      return _.filter(this.whatsNewData, item => item[this.currentLanguageCode])
    },
    currentLanguageCode() {
      return _.get(this.$store.getters.currentLanguage, 'isoCode', '').substr(0, 2)
    },
    features() {
      return this.getItems(`features`)
    },
    fixes() {
      return this.getItems(`fixes`)
    }
  },
  watch: {
    username: {
      immediate: true,
      handler(name) {
        if(name) {
          this.getWhatsNewPopupData()
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  img.preloaded { display: none; }

  .whats-new-modal__container {
    padding: measure(l)
  }

  .whats-new-modal__header {
    @include font-size(l);
    margin-bottom: measure(l);
  }

  .whats-new-modal__category {
    @include font-size(s);
    display: inline-block;
    margin-bottom: measure(m);
    padding: measure(xxs) measure(s);
    background-color: color(primary, 0.5);
    border-radius: 3px;
  }

  .whats-new-modal__list {
    margin: 0 0 measure(l) 0;
    padding: 0 measure(m);
  }

  .whats-new-modal__list-item {
    margin-bottom: measure(s);

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .whats-new-modal__details-image {
    width: 100%;
    margin-bottom: measure(l);
  }

  .whats-new-modal__details-header {
    @include font-size(l);
    margin-top: 0;
    margin-bottom: measure(l);
  }

  .whats-new-modal__details-content {
    margin-bottom: measure(xl);
  }
</style>
